<template>
  <span v-if="sortOptions" class="stack-horizontally stack-align-middle"
    ><small class="mrx">{{ sortLabel }}</small>
    <inline-menu
      button
      hollow
      small
      :value="selectedIndex"
      :items="menuOptions"
      @ui-select="selectSort"
    ></inline-menu>
  </span>
</template>
<script lang="ts">
import {
  Component,
  Vue,
  Prop,
  mixins,
  Emit,
  Inject
} from "vue-facing-decorator";
import ServicedMixin, { Labeled, defaultResolveTxt } from "../field-element";
import InlineMenu from "../catMenu/catMenu.vue";
import MenuItem from "../catMenu/menuItem";
export enum SortDir {
  asc = "asc",
  desc = "desc"
}

export interface SortOption {
  value: number;
  text: string;
  dir: SortDir;
  data?: any;
}
@Component({
  name: "cat-sort",
  components: { InlineMenu },
  mixins: [ServicedMixin]
})
export default class RepeaterSort extends Vue implements Labeled {
  @Prop({ default: 0 }) readonly selectedIndex!: number;
  @Prop() readonly sortOptions: Array<SortOption> | undefined;
  @Prop() readonly label: string | undefined;

  @Inject({
    default: defaultResolveTxt,
    from: "resolveTxt"
  })
  readonly resolveTxt!: Function;

  @Emit("ui-select-sort")
  selectSort(obj) {
    return { value: obj.text, index: obj.value };
  }

  get sortLabel(): string {
    if (this.label) {
      return this.label;
    }
    return this.resolveTxt("skin.sort", "Sort by");
  }

  get menuOptions(): Array<MenuItem> | null {
    if (this.sortOptions) {
      return this.sortOptions.map((item, idx) => {
        return {
          text: item.text,
          value: idx
        };
      });
    }
    return null;
  }
}
</script>
